import { useEffect, useState } from 'react';

/** Number input that lets you type freely ("1.", "") and reports parsed numbers. */
export default function NumInput({ value, onChange, placeholder, style, disabled, ariaLabel }: {
  value: number | undefined | null;
  onChange: (v: number | undefined) => void;
  placeholder?: string;
  style?: React.CSSProperties;
  disabled?: boolean;
  ariaLabel?: string;
}) {
  const [text, setText] = useState(value == null ? '' : String(value));
  useEffect(() => {
    const parsed = text.trim() === '' ? undefined : Number(text);
    if (parsed !== (value ?? undefined)) setText(value == null ? '' : String(value));
    // only resync when the outside value changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);
  return (
    <input className="num" inputMode="decimal" value={text} placeholder={placeholder} style={style}
      disabled={disabled} aria-label={ariaLabel}
      onChange={(e) => {
        const t = e.target.value.replace(/[$,%\s]/g, '');
        setText(e.target.value);
        if (t === '') onChange(undefined);
        else if (Number.isFinite(Number(t))) onChange(Number(t));
      }} />
  );
}
